import { render } from "./SearchResultItem.vue?vue&type=template&id=335b527b&scoped=true"
import script from "./SearchResultItem.vue?vue&type=script&lang=js"
export * from "./SearchResultItem.vue?vue&type=script&lang=js"

import "./SearchResultItem.vue?vue&type=style&index=0&id=335b527b&scoped=true&lang=css"

import exportComponent from "C:\\TeamCode\\PFSearch\\PFSearch\\pfsearch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335b527b"]])

export default __exports__